/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import makeMutationHook from 'core/types/makeMutationHook'
import makeQueryHook from 'core/types/makeQueryHook'
import * as operations from 'core/types/operations'

export const useCompanyGetAll = makeQueryHook(operations.companyGetAll)

export const useCreateCompany = makeMutationHook(operations.createCompany)

export const useCompanyGet = makeQueryHook(operations.companyGet)

export const useUpdateCompany = makeMutationHook(operations.updateCompany)

export const useCompanyAppDomainGetAll = makeQueryHook(
  operations.companyAppDomainGetAll,
)

export const useCompanyAppDomainPost = makeMutationHook(
  operations.companyAppDomainPost,
)

export const useCompanyAppDomainGet = makeQueryHook(
  operations.companyAppDomainGet,
)

export const useCompanyAppDomainPut = makeMutationHook(
  operations.companyAppDomainPut,
)

export const useGetCompanyConfig = makeQueryHook(operations.getCompanyConfig)

export const useSetCompanyConfig = makeMutationHook(operations.setCompanyConfig)

export const useLegacyUpdatePlaidCredentials = makeMutationHook(
  operations.legacyUpdatePlaidCredentials,
)

export const useUpdatePlaidCredentials = makeMutationHook(
  operations.updatePlaidCredentials,
)

export const useUpdateSendgridCredentials = makeMutationHook(
  operations.updateSendgridCredentials,
)

export const useThirdPartyUpdatePlaidCredentials = makeMutationHook(
  operations.thirdPartyUpdatePlaidCredentials,
)

export const useGetByoTwilio = makeQueryHook(operations.getByoTwilio)

export const useUpdateByoTwilio = makeMutationHook(operations.updateByoTwilio)

export const useSyncByoTwilio = makeMutationHook(operations.syncByoTwilio)

export const useProvisionCompanyTwilio = makeMutationHook(
  operations.provisionCompanyTwilio,
)
